/* eslint-disable no-undef */
import api from "./ApiService";
import { handlingUrlParams } from "Utils/AppUtils";

const getInvoiceDetailSummary = (customerId?: number | null) => {
  const query =
    customerId !== undefined && customerId !== null
      ? `?${handlingUrlParams({ CustomerId: customerId })}`
      : "";

  return api
    .get<any>(
      process.env.REACT_APP_API_BASE_URL +
        `/InvestorDelivery/InvoiceDetail/summary${query}`
    )
    .then((response: any) => {
      return response;
    });
};

const getInvoiceDetails = (params: {
  customerId: number;
  billMonth: string;
  billYear: number;
  pageNumber: number;
  pageSize: number;
}) => {
  const query = handlingUrlParams({
    CustomerId: params.customerId,
    BillMonth: params.billMonth,
    BillYear: params.billYear,
    PageNumber: params.pageNumber,
    PageSize: params.pageSize,
  });
  const endpoint =
    process.env.REACT_APP_API_BASE_URL +
    `/InvestorDelivery/InvoiceDetail?${query}`;

  return api.get<any>(endpoint).then((response: any) => {
    return response;
  });
};

const getMersInvoiceDetailSummary = (customerId?: number | null) => {
  const query =
    customerId !== undefined && customerId !== null
      ? `?${handlingUrlParams({ CustomerId: customerId })}`
      : "";

  return api
    .get<any>(
      process.env.REACT_APP_API_BASE_URL + `/Mers/InvoiceDetail/summary${query}`
    )
    .then((response: any) => {
      return response;
    });
};

const getMersInvoiceDetails = (params: {
  customerId: number;
  billMonth: string;
  billYear: number;
  pageNumber: number;
  pageSize: number;
}) => {
  const query = handlingUrlParams({
    CustomerId: params.customerId,
    BillMonth: params.billMonth,
    BillYear: params.billYear,
    PageNumber: params.pageNumber,
    PageSize: params.pageSize,
  });
  const endpoint =
    process.env.REACT_APP_API_BASE_URL + `/Mers/InvoiceDetail?${query}`;

  return api.get<any>(endpoint).then((response: any) => {
    return response;
  });
};

const InvestorDeliveryInvoiceService = {
  getInvoiceDetailSummary,
  getInvoiceDetails,
  getMersInvoiceDetailSummary,
  getMersInvoiceDetails,
};

export default InvestorDeliveryInvoiceService;
